import React from 'react'
import PropTypes from 'prop-types'
// import R from 'ramda'
import {
  SESSION_LENGTH_VALUES
} from '_constants'

import BaseSelectField from './baseSelect'

const SessionLengthField = ({
  name,
  width,
  onChange,
  lengthInMinutes,
  readOnly = false
}) => (
  <BaseSelectField
    readOnly={ readOnly }
    name = {name}
    width = {width}
    onChange = {onChange}
    value={lengthInMinutes}
    labelTxt = 'Session Length'
    popupTxt='How long can a machine that uses this license go offline?  A shorter time will allow you to switch machines more frequently.'
    options={SESSION_LENGTH_VALUES}
  />
)

SessionLengthField.propTypes = {
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  lengthInMinutes: PropTypes.number.isRequired
}
export default SessionLengthField



// WEBPACK FOOTER //
// ./webAdmin/forms/sessionLengthField.js